import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Eventstransportationsericepune() {



  const cardData =
  {
    keyword: ' Event Transportation Services in Pune ',
    heading: 'Pune Corporate Cars India Private Limited: Event Transportation Services in Pune ',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional Event Transportation Services in Pune, delivering reliable and well-coordinated travel solutions for corporate events, product launches, exhibitions, trade fairs, annual meets, award functions, and large-scale business gatherings. Our fleet of well-maintained sedans, SUVs, MUVs, tempo travellers, and premium vehicles ensures safe, comfortable, and timely transportation for guests, delegates, employees, and VIP attendees. Whether it is airport pick-ups, venue transfers, shuttle services, inter-city travel, or full-day event logistics, we offer seamless and hassle-free mobility management. With trained chauffeurs, GPS-enabled vehicles, 24×7 live support, flexible rental options, and dedicated event coordination, Pune Corporate Cars India Private Limited ensures a smooth, organized, and premium transportation experience for events of every scale across Pune.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

"topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],


"services": [
  {
    "name": "Corporate Event Cab Pune",
    "description": "Corporate Event Cab Pune provides end-to-end transport solutions for corporate events, including VIP transfers, staff mobility, and guest pickups with professional chauffeurs and GPS-enabled tracking for punctual and safe commuting."
  },
  {
    "name": "Seminar Transport Pune",
    "description": "Seminar Transport Pune offers structured transport services for delegates and staff attending seminars, with shuttle services, pre-planned routes, and real-time monitoring to ensure timely arrival and departure."
  },
  {
    "name": "Exhibition Transportation Pune",
    "description": "Exhibition Transportation Pune provides large-scale mobility solutions for exhibition attendees and staff, including group shuttles, multi-route coordination, and comfortable vehicles to handle high-capacity event transportation."
  },
  {
    "name": "Business Event Shuttle Pune",
    "description": "Business Event Shuttle Pune delivers efficient shuttle services for corporate meetings, conferences, and networking events, ensuring smooth, safe, and coordinated movement of attendees across venues."
  },
  {
    "name": "VIP Event Cars Pune",
    "description": "VIP Event Cars Pune offers premium, chauffeur-driven vehicles for high-profile guests, executives, and delegates attending corporate or private events, providing comfort, privacy, and professional service."
  },
  {
    "name": "Wedding Guest Transport Pune",
    "description": "Wedding Guest Transport Pune provides reliable transport services for wedding attendees, including sedans, SUVs, and shuttles, ensuring timely arrivals, comfortable travel, and well-managed group mobility."
  },
  {
    "name": "Concert Staff Transport Pune",
    "description": "Concert Staff Transport Pune manages transportation for event staff, performers, and crew during concerts, with dedicated shuttles, scheduled pickups, and secure, efficient transit arrangements."
  },
  {
    "name": "Festival Transportation Pune",
    "description": "Festival Transportation Pune offers coordinated mobility solutions for large-scale festival events, including shuttle services, group transport, and multi-venue travel to ensure smooth crowd management and timely movement."
  },
  {
    "name": "Event Logistics Cab Pune",
    "description": "Event Logistics Cab Pune provides flexible transport services for event logistics, including guest pickups, staff movement, and equipment transport, ensuring organized and dependable travel during event operations."
  },
  {
    "name": "Executive Event Fleet Pune",
    "description": "Executive Event Fleet Pune offers a managed fleet of premium vehicles for event executives and VIPs, complete with trained chauffeurs, GPS tracking, and seamless scheduling to ensure professional and comfortable mobility."
  },
  {
    "name": "Chauffeur Event Cars Pune",
    "description": "Chauffeur Event Cars Pune delivers high-end chauffeur-driven cars for VIP guests and executives attending events, ensuring comfort, luxury, and timely transportation across venues."
  },
  {
    "name": "Group Shuttle Pune",
    "description": "Group Shuttle Pune provides organized shuttle services for transporting multiple attendees or staff in one trip, featuring optimized routes, multi-pickup scheduling, and real-time tracking for event mobility."
  },
  {
    "name": "Staff Mobility Event Pune",
    "description": "Staff Mobility Event Pune ensures seamless daily transport for event staff, including pick-ups, drop-offs, and multi-shift coordination with GPS monitoring and professional drivers for efficient workforce movement."
  },
  {
    "name": "Affordable Event Cab Pune",
    "description": "Affordable Event Cab Pune offers budget-friendly transport solutions for events, combining reliability, safety, and comfort for delegates, staff, and attendees without compromising service quality."
  },
  {
    "name": "Outsourced Event Transport Pune",
    "description": "Outsourced Event Transport Pune provides third-party managed transportation solutions for large events, including fleet management, driver coordination, route optimization, and real-time tracking for a fully managed travel experience."
  }
],

"tableData": [
  ["Corporate Event Cab Pune", "Seminar Transport Pune"],
  ["Exhibition Transportation Pune", "Business Event Shuttle Pune"],
  ["VIP Event Cars Pune", "Wedding Guest Transport Pune"],
  ["Concert Staff Transport Pune", "Festival Transportation Pune"],
  ["Event Logistics Cab Pune", "Executive Event Fleet Pune"],
  ["Chauffeur Event Cars Pune", "Group Shuttle Pune"],
  ["Staff Mobility Event Pune", "Affordable Event Cab Pune"],
  ["Outsourced Event Transport Pune", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Event Transportation Services in Pune",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers reliable event transportation services in Pune, ensuring smooth and efficient travel for guests, delegates, and corporate attendees at conferences, seminars, and special events."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We provide punctual pickups and drop-offs, helping event attendees reach venues, hotels, and airports on time without any hassle."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs deliver safe, courteous, and disciplined travel, ensuring a secure and comfortable journey for all event participants."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for reliable and comfortable transportation during events in Pune."
  },
  {
    "WhyChooseheading": "Customized Event Transport Solutions",
    "WhyChoosedescription": "We offer flexible and tailored transportation packages to meet the specific needs of corporate events, conferences, and private functions."
  },
  {
    "WhyChooseheading": "24/7 Support for Event Transportation",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, route adjustments, and emergencies, ensuring smooth and uninterrupted travel for event attendees."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, providing secure and hygienic rides for all guests and delegates."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Event transportation is managed efficiently through our streamlined booking process and reliable coordination, making travel for conferences and events hassle-free."
  }
]





















  }

  
const faqData = [
  {
    question: 'Do you provide event transportation services in Pune?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers professional and reliable transportation services for corporate events, weddings, conferences, and other special events in Pune.',
  },
  {
    question: 'What types of event transportation services are available?',
    answer: 'We provide shuttle services, VIP transfers, multi-vehicle coordination, airport pickups and drops, and customized transport solutions for guests and participants.',
  },
  {
    question: 'Can multiple vehicles be booked for large events in Pune?',
    answer: 'Absolutely. We can provide a fleet of vehicles for large events, ensuring timely and coordinated transport for all attendees.',
  },
  {
    question: 'How can event organizers book transportation services in Pune?',
    answer: 'Bookings can be made through our website, mobile app, or by contacting our 24×7 dedicated corporate support team.',
  },
  {
    question: 'Which vehicles are available for event transportation?',
    answer: 'We offer hatchbacks, sedans, SUVs, luxury cars, Innova Crysta, tempo travellers, and electric vehicles based on the event’s requirements.',
  },
  {
    question: 'Do you offer flexible contracts for event transportation?',
    answer: 'Yes, we provide single-day, multi-day, or recurring event transportation contracts tailored to your needs.',
  },
  {
    question: 'Are your vehicles GPS-enabled and safe for event guests?',
    answer: 'All vehicles are GPS-enabled, sanitized regularly, and driven by trained and verified chauffeurs to ensure safety and comfort.',
  },
  {
    question: 'Do you accommodate last-minute changes in event transportation schedules?',
    answer: 'Absolutely. We offer flexible solutions to handle schedule changes, additional vehicles, or urgent transport requests.',
  },
  {
    question: 'What payment options are available for event transportation services?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and provide consolidated invoicing for event organizers.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Karan Mehta',
    feedback: 'Highly reliable event transportation service in Pune. Vehicles and drivers ensured smooth and timely transportation for all our guests.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Gupta',
    feedback: 'Excellent service for corporate and private events. Timely pickups, comfortable rides, and professional drivers made our event hassle-free.',
    rating: 5,
  },
];


















































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Event Transportation Services in Pune",
  "image": "https://www.punecorporatecars.com/assets/images/event-transportation-pune.jpg", // replace with actual image URL
  "description":
    "Pune Corporate Cars India Private Limited provides premium Event Transportation Services in Pune for corporate events, seminars, exhibitions, weddings, concerts, festivals, and more. Offering VIP event cars, business event shuttles, executive event fleets, chauffeur-driven cars, and group shuttle services, we ensure your event transport runs smoothly and professionally.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/event-transportation-services-pune"
  }
};






  return (
    <div>

<Helmet>
  <title>Event Transportation Services in Pune | Corporate & VIP Event Transport</title>

  <meta
    name="description"
    content="Event Transportation Services in Pune offering corporate event cabs, seminar transport, exhibition transportation, business event shuttles, wedding guest transport, concert staff transport, festival transportation, VIP event cars, chauffeur-driven cars, and more."
  />

  <meta
    name="keywords"
    content="Corporate Event Cab Pune, Seminar Transport Pune, Exhibition Transportation Pune, Business Event Shuttle Pune, VIP Event Cars Pune, Wedding Guest Transport Pune, Concert Staff Transport Pune, Festival Transportation Pune, Event Logistics Cab Pune, Executive Event Fleet Pune, Chauffeur Event Cars Pune, Group Shuttle Pune, Staff Mobility Event Pune, Affordable Event Cab Pune, Outsourced Event Transport Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/107.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Eventstransportationsericepune;